// @generated by protoc-gen-grpc-gateway-es v0.5.0 with parameter "target=ts,generate_name_parser=true"
// @generated from file h2ogpte/h2ogpte.proto (package h2ogpte, syntax proto3)
/* eslint-disable */

import type { BigIntString } from "../runtime";
import { RPC } from "../runtime";

/**
 * @generated from message h2ogpte.GpteEventRequest
 */
export type GpteEventRequest = {
/**
 * @generated from field: string resource = 1;
 */
resource?: string;
/**
 * @generated from field: string action = 2;
 */
action?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 3;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 4;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 5;
 */
timezone?: string;
}
;
/**
 * @generated from message h2ogpte.GpteEventResponse
 */
export type GpteEventResponse = {
/**
 * @generated from field: repeated h2ogpte.GpteEvent events = 1;
 */
events?: GpteEvent[];
}
;
/**
 * @generated from message h2ogpte.GpteEvent
 */
export type GpteEvent = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string user_name = 2;
 */
userName?: string;
/**
 * @generated from field: string resource = 3;
 */
resource?: string;
/**
 * @generated from field: string action = 4;
 */
action?: string;
/**
 * @generated from field: int32 count = 5;
 */
count?: number;
}
;
/**
 * @generated from message h2ogpte.GpteUsageStatsRequest
 */
export type GpteUsageStatsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 3;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 4;
 */
endDate?: string;
}
;
/**
 * @generated from message h2ogpte.GpteUsageStatsResponse
 */
export type GpteUsageStatsResponse = {
/**
 * @generated from field: map<string, int32> llm_usage = 1;
 */
llmUsage?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> llm_description = 2;
 */
llmDescription?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> api_called = 3;
 */
apiCalled?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> rpc_called = 4;
 */
rpcCalled?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> chat_actions = 5;
 */
chatActions?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> collection_actions = 6;
 */
collectionActions?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> document_actions = 7;
 */
documentActions?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> job_actions = 8;
 */
jobActions?: { [key: string]: number };
/**
 * @generated from field: map<string, int32> other_actions = 9;
 */
otherActions?: { [key: string]: number };
}
;
/**
 * @generated from message h2ogpte.GpteTokenConsumptionStatsRequest
 */
export type GpteTokenConsumptionStatsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * @generated from field: h2ogpte.UserContext user_context = 3;
 */
userContext?: UserContext;
}
;
/**
 * @generated from message h2ogpte.GpteTokenConsumptionStatsResponse
 */
export type GpteTokenConsumptionStatsResponse = {
/**
 * @generated from field: int64 total_input_tokens = 1;
 */
totalInputTokens?: BigIntString;
/**
 * @generated from field: int64 total_output_tokens = 2;
 */
totalOutputTokens?: BigIntString;
/**
 * @generated from field: float average_tokens_per_message = 3;
 */
averageTokensPerMessage?: number;
/**
 * @generated from field: string most_used_llm = 4;
 */
mostUsedLlm?: string;
/**
 * @generated from field: int64 total_tokens_of_most_used_llm = 5;
 */
totalTokensOfMostUsedLlm?: BigIntString;
/**
 * @generated from field: int32 most_used_llm_count = 6;
 */
mostUsedLlmCount?: number;
}
;
/**
 * @generated from message h2ogpte.TokenUsage
 */
export type TokenUsage = {
/**
 * @generated from field: int64 input_tokens = 1;
 */
inputTokens?: BigIntString;
/**
 * @generated from field: int64 output_tokens = 2;
 */
outputTokens?: BigIntString;
}
;
/**
 * @generated from message h2ogpte.GpteDailyTokensUsageRequest
 */
export type GpteDailyTokensUsageRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 3;
 */
timezone?: string;
}
;
/**
 * @generated from message h2ogpte.GpteDailyTokensUsageResponse
 */
export type GpteDailyTokensUsageResponse = {
/**
 * @generated from field: map<string, h2ogpte.TokenUsage> data = 1;
 */
data?: { [key: string]: TokenUsage };
}
;
/**
 * @generated from message h2ogpte.GpteLLMTokensUsageRequest
 */
export type GpteLLMTokensUsageRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message h2ogpte.GpteLLMTokensUsageResponse
 */
export type GpteLLMTokensUsageResponse = {
/**
 * @generated from field: map<string, h2ogpte.TokenUsage> data = 1;
 */
data?: { [key: string]: TokenUsage };
}
;
/**
 * @generated from message h2ogpte.GetGpteEventCountsRequest
 */
export type GetGpteEventCountsRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
/**
 * IANA timezone name (e.g. "Asia/Colombo"). The daily buckets in the response follow it, so
 * DST transitions inside the range are handled correctly and the days stay right even when no
 * dates are sent. Falls back to the fixed offset carried by start_date when empty.
 *
 * @generated from field: string timezone = 3;
 */
timezone?: string;
}
;
/**
 * @generated from message h2ogpte.GPTeEventCount
 */
export type GPTeEventCount = {
/**
 * @generated from field: int32 chat = 1;
 */
chat?: number;
/**
 * @generated from field: int32 api_called = 2;
 */
apiCalled?: number;
/**
 * @generated from field: int32 rpc_called = 3;
 */
rpcCalled?: number;
/**
 * @generated from field: int32 collection = 4;
 */
collection?: number;
/**
 * @generated from field: int32 document = 5;
 */
document?: number;
/**
 * @generated from field: int32 job = 6;
 */
job?: number;
/**
 * @generated from field: int32 other = 7;
 */
other?: number;
}
;
/**
 * @generated from message h2ogpte.GetGpteEventCountsResponse
 */
export type GetGpteEventCountsResponse = {
/**
 * @generated from field: map<string, h2ogpte.GPTeEventCount> data = 1;
 */
data?: { [key: string]: GPTeEventCount };
}
;
/**
 * models
 *
 * @generated from message h2ogpte.H2oGPTeEventRecord
 */
export type H2oGPTeEventRecord = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string username = 2;
 */
username?: string;
/**
 * @generated from field: string resource = 3;
 */
resource?: string;
/**
 * @generated from field: string action = 4;
 */
action?: string;
/**
 * @generated from field: int32 count = 5;
 */
count?: number;
}
;
/**
 * @generated from message h2ogpte.H2oGPTeLLMsRecord
 */
export type H2oGPTeLLMsRecord = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string type = 2;
 */
type?: string;
/**
 * @generated from field: string value = 3;
 */
value?: string;
/**
 * @generated from field: int32 count = 4;
 */
count?: number;
}
;
/**
 * @generated from message h2ogpte.H2oGPTeTokensRecord
 */
export type H2oGPTeTokensRecord = {
/**
 * @generated from field: string hour = 1;
 */
hour?: string;
/**
 * @generated from field: string username = 2;
 */
username?: string;
/**
 * @generated from field: string llm = 3;
 */
llm?: string;
/**
 * @generated from field: int64 input_tokens = 4;
 */
inputTokens?: BigIntString;
/**
 * @generated from field: int64 output_tokens = 5;
 */
outputTokens?: BigIntString;
/**
 * @generated from field: int32 count = 6;
 */
count?: number;
}
;
/**
 * @generated from message h2ogpte.GpteUserUsageRequest
 */
export type GpteUserUsageRequest = {
/**
 * RFC3339 format with timezone (e.g., "2025-01-01T00:00:00-05:00")
 *
 * @generated from field: string start_date = 1;
 */
startDate?: string;
/**
 * RFC3339 format with timezone (e.g., "2025-01-31T23:59:59-05:00")
 *
 * @generated from field: string end_date = 2;
 */
endDate?: string;
}
;
/**
 * @generated from message h2ogpte.GpteUserUsageResponse
 */
export type GpteUserUsageResponse = {
/**
 * @generated from field: repeated h2ogpte.UserUsageMetrics data = 1;
 */
data?: UserUsageMetrics[];
}
;
/**
 * @generated from message h2ogpte.UserUsageMetrics
 */
export type UserUsageMetrics = {
/**
 * @generated from field: string username = 1;
 */
username?: string;
/**
 * @generated from field: int64 input_tokens = 2;
 */
inputTokens?: BigIntString;
/**
 * @generated from field: int64 output_tokens = 3;
 */
outputTokens?: BigIntString;
/**
 * @generated from field: int64 total_tokens = 4;
 */
totalTokens?: BigIntString;
/**
 * @generated from field: int32 message_count = 5;
 */
messageCount?: number;
/**
 * @generated from field: int32 event_count = 6;
 */
eventCount?: number;
}
;
/**
 * @generated from message h2ogpte.UserContext
 */
export type UserContext = {
/**
 * @generated from field: string user_email = 1;
 */
userEmail?: string;
/**
 * @generated from field: string source_ip_address = 2;
 */
sourceIpAddress?: string;
/**
 * @generated from field: string user_agent = 3;
 */
userAgent?: string;
}
;
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetGpteEvents
 */
export const H2oGpteService_GetGpteEvents = new RPC<GpteEventRequest,GpteEventResponse>("GET", "/getGpteEvents");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetGpteUsageStats
 */
export const H2oGpteService_GetGpteUsageStats = new RPC<GpteUsageStatsRequest,GpteUsageStatsResponse>("GET", "/getGpteUsageStats");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetTokenConsumptionStats
 */
export const H2oGpteService_GetTokenConsumptionStats = new RPC<GpteTokenConsumptionStatsRequest,GpteTokenConsumptionStatsResponse>("POST", "/getTokenConsumptionStats");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetDailyTokenUsage
 */
export const H2oGpteService_GetDailyTokenUsage = new RPC<GpteDailyTokensUsageRequest,GpteDailyTokensUsageResponse>("GET", "/getDailyTokenUsage");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetLLMTokenUsage
 */
export const H2oGpteService_GetLLMTokenUsage = new RPC<GpteLLMTokensUsageRequest,GpteLLMTokensUsageResponse>("GET", "/getLLMTokenUsage");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetGpteEventCounts
 */
export const H2oGpteService_GetGpteEventCounts = new RPC<GetGpteEventCountsRequest,GetGpteEventCountsResponse>("GET", "/getGpteEventCounts");
/**
 * @generated from rpc h2ogpte.H2oGpteService.GetUserUsageMetrics
 */
export const H2oGpteService_GetUserUsageMetrics = new RPC<GpteUserUsageRequest,GpteUserUsageResponse>("GET", "/getUserUsageMetrics");
